module.exports = __webpack_public_path__ + "img/product-34.010ff4a4.jpg";